import React from 'react';
import withStyles from '@mui/styles/withStyles';
import { Switch, Route } from 'react-router-dom';
import Report from 'containers/report/report';
import QsReport from 'containers/report/qs-report';
import { styles } from '../nav-styles';

interface IReportsProps {
  classes: Record<string, string>;
}
const Reports = ({ classes }: IReportsProps) => (
  <div className={classes.reportContent}>
    <Switch>
      <Route path="/customers/:customerId/reports/qs-report" component={QsReport} />
      <Route component={Report} />
    </Switch>
  </div>
);

export default withStyles(styles as any, { withTheme: true })(Reports);
